module.exports = __webpack_public_path__ + "img/SISGEOMOVSALA6.a49f2780.svg";